import { TERMS_LINKS } from '@avalara/bat-apps-shared/lib/constants';
import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { updateProductAnalytics } from '../../lib/side-effects/analytics';
import { purchaseOffer } from '../../lib/side-effects/offers';
import { goToPreviousOfferStep } from '../../lib/side-effects/offer-flow';
import { isFormIncomplete } from '../../lib/shared-signup';
import { selectState, selectIsNonAdmin } from '../../selectors';
import { isEmbeddedSelector } from '../../selectors/offer';
import { termsUrls } from '../../../shared/constants';
import { getOrderSummary, getPlanSpecificBillingTerms } from '../../selectors/order';
import ExternalLink from '../external-link';
import { getBillingTerms } from './billing-terms';
const BuyButton = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { account: { isLoggedIn, selectedPaymentMethod, }, offer: { buyButtonTextOverride, isFreeTrial, isPaymentRequired, offerFlow, showEmbeddedSideContent, termsAndConditions, }, order: { discountAdditionalLegalText, }, sharedSignup, } = useSelector(selectState);
    const { showBillingTermsInOrderSummary, } = useSelector(getOrderSummary);
    const onSubmit = () => {
        dispatch(updateProductAnalytics('buy_now', true));
        if (!isPaymentRequired)
            dispatch(purchaseOffer(history));
        else if (selectedPaymentMethod)
            dispatch(purchaseOffer(history, selectedPaymentMethod.Id));
    };
    const goBack = () => dispatch(goToPreviousOfferStep(history));
    const displayedTermsAndConditions = (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.length)
        ? termsAndConditions
        : [{
                text: 'Avalara Service Terms and Conditions',
                url: TERMS_LINKS.general,
            }];
    const signupIncomplete = !isLoggedIn && isFormIncomplete(sharedSignup);
    const isNonAdmin = useSelector(selectIsNonAdmin);
    const disabled = signupIncomplete || (isLoggedIn && isNonAdmin);
    const isEmbedded = useSelector(isEmbeddedSelector);
    const planSpecificBillingTerms = useSelector(getPlanSpecificBillingTerms);
    const showBillingTerms = !showBillingTermsInOrderSummary && isPaymentRequired;
    let buttonText;
    if (buyButtonTextOverride)
        buttonText = buyButtonTextOverride;
    else
        buttonText = isFreeTrial ? 'Start your free trial' : 'Finish';
    const getTermsAndConditions = displayedTermsAndConditions.map((tc, i) => React.createElement(Fragment, { key: `tc${i}` },
        i > 0 && ', ',
        i > 0 && i === displayedTermsAndConditions.length - 1 && 'and ',
        React.createElement(ExternalLink, { href: tc.url, alwaysOpenInNewTab: true }, tc.text)));
    const getAgreementTerms = () => {
        switch (offerFlow) {
            case 'ioss':
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { "data-ref": 'buy.ioss.agreement-terms' },
                        "By clicking ",
                        React.createElement("span", { className: 'font-bold' }, buttonText),
                        " you are purchasing a recurring, 12-month subscription, and you acknowledge that you have reviewed and agreed to be bound by the ",
                        getTermsAndConditions,
                        "."),
                    React.createElement("p", { "data-ref": 'buy.ioss.cancellation-terms', className: 'pad-top-md' },
                        " You must cancel on or before the expiration date of the then-current subscription term to avoid additional charges. Information on how to cancel is available here: ",
                        React.createElement("a", { href: termsUrls.cancellation, target: '_blank', rel: 'noopener noreferrer' },
                            termsUrls.cancellation,
                            ".")));
            case 'free-trial':
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { "data-ref": 'buy.free-trial.agreement-terms' },
                        "By selecting ",
                        React.createElement("span", { className: 'font-bold' },
                            buttonText,
                            ","),
                        " you agree to Avalara\u2019s ",
                        getTermsAndConditions,
                        "."));
            default:
                return React.createElement(React.Fragment, null,
                    React.createElement("p", null,
                        "By clicking ",
                        React.createElement("span", { className: 'font-bold' }, buttonText),
                        ":"),
                    React.createElement("br", null),
                    React.createElement("ul", { className: 'pad-left-lg' },
                        React.createElement("li", { "data-ref": 'buy.default.agreement-terms' },
                            "You accept the ",
                            getTermsAndConditions,
                            "; and"),
                        React.createElement("li", { "data-ref": 'buy.default.cancellation-terms' },
                            " You are purchasing a recurring, 12-month subscription that must be cancelled on or before the expiration date of the then-current subscription term to avoid additional charges. Information on how to cancel is available here: ",
                            React.createElement(ExternalLink, { href: termsUrls.cancellation, alwaysOpenInNewTab: true }, termsUrls.cancellation),
                            ".")));
        }
    };
    return (React.createElement("div", { className: 'pad-top-md' },
        React.createElement("div", { className: isEmbedded ? 'text-right' : '' },
            isEmbedded && (isPaymentRequired || !showEmbeddedSideContent) &&
                React.createElement("button", { className: 'secondary margin-right-lg', "data-ref": 'buydot.buy-now.back-button', onClick: goBack }, "Back"),
            (selectedPaymentMethod || !isPaymentRequired) && React.createElement("button", { id: 'submit-payment', className: 'primary', "data-ref": 'buydot.buy-now.buy-button', disabled: disabled, onClick: onSubmit }, buttonText)),
        React.createElement("div", { className: 'margin-top-sm' },
            React.createElement("div", { className: isEmbedded ? 'text-right' : '' }, offerFlow && getAgreementTerms()),
            showBillingTerms && offerFlow && React.createElement("div", null, getBillingTerms(planSpecificBillingTerms, offerFlow).map((term, i) => (React.createElement("p", { key: `billingTerm${i}`, className: 'pad-top-sm', "data-ref": `buy-button-billing-terms.${offerFlow}.term-${i}` }, term)))),
            discountAdditionalLegalText &&
                React.createElement("p", { className: 'margin-top-sm' }, discountAdditionalLegalText))));
};
export default BuyButton;
